import type { BetSlipState, ErrorMessage } from '../../types/betSlip';
import { getSelectionsFromSingleOpportunities } from '../../utils/betSlip/getSelectionsFromSingleOpportunities';

/**
 * Ensures the selections reset to whats actually in the customers bet slip upon failures
 * This ensures the catalogue and bet slip are always aligned.
 */
const betSlipUpdateFailed = (state: BetSlipState, errorMessage: ErrorMessage): BetSlipState => {
  let { selections } = state;
  const selectionsRequireResetting = state.opportunities.SINGLE.length !== selections.length;

  // To avoid recursive API calls, we should only update selections when they are
  // different to the opportunities available in the bet slip.
  if (selectionsRequireResetting) {
    selections = getSelectionsFromSingleOpportunities(state.opportunities.SINGLE);
  }

  return {
    ...state,
    errorMessage,
    isAutoDismissibleError: undefined,
    selections,
    fetchStatus: 'READY'
  };
};

export default betSlipUpdateFailed;
